import imageAliases from "./productImageAliases.json";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
if (!backendUrl) throw new Error("REACT_APP_BACKEND_URL is required");
const backendOrigin = new URL(backendUrl).origin;

export const resolveProductImage = (imageUrl) => {
  const source = typeof imageUrl === "string" ? imageUrl.trim() : "";
  if (!source) return "";
  try {
    let url = new URL(imageAliases[source] || source, backendOrigin);
    const isLocalAsset = url.pathname.startsWith("/api/static/products/");
    if (isLocalAsset && (url.origin === backendOrigin || url.hostname.endsWith(".preview.emergentagent.com"))) {
      url = new URL(imageAliases[url.pathname] || url.pathname, backendOrigin);
    }
    return ["https:", "http:"].includes(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
};